var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-column justify-content-center"},[_c('b-col',{staticClass:"text-center text-light"},[_c('chipincancel')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }